import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import { GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { UwContext } from '@ps20-frontend/uw';
import { VhvActions } from '../vhvActions';
import { IAppState } from '../appState';
import {
  selectHasWeitereNaturgefahrenSelected,
  selectIsExtremwetterUWProcessNecessary,
} from '../../app/shared/selectors/produkt.selector';

export function* watchConfirmUwApprovedOfferEdition() {
  yield takeEvery(
    GlobalActions.CONFIRM_UW_APPROVED_OFFER_EDITION,
    safeSaga(confirmUwApprovedOfferEdition, App.VHV_V2),
  );
}

export function* confirmUwApprovedOfferEdition(action: {
  type: string;
  payload?: { appId: App; angebotsId: string };
}) {
  const globalPut = GlobalPut.getInstance();
  const globalActions = new GlobalActions();
  const { appId, angebotsId } = action.payload || { appId: null, angebotsId: null };

  const initialState: IAppState = yield select();

  if (appId !== App.VHV_V2 || angebotsId !== initialState.angebotsId) {
    return;
  }

  const hasWeitereNaturgefahren = selectHasWeitereNaturgefahrenSelected(initialState);
  const isUnderwriterInfoVisible = selectIsExtremwetterUWProcessNecessary(initialState);
  const requiredByContext = { [UwContext.NATURAL_HAZARDS]: isUnderwriterInfoVisible };

  if (!initialState.vertragsoptionen?.beibehalten && hasWeitereNaturgefahren) {
    yield call(
      [globalPut, globalPut.put],
      globalActions.setNeedsUwResubmission(true, angebotsId, requiredByContext),
    );
  }

  yield call(
    [globalPut, globalPut.put],
    globalActions.setUnderwriterInfo(angebotsId, requiredByContext),
  );

  yield put(new VhvActions().requestPreis());

  yield take(GlobalActions.GESAMTPREIS_CHANGED);

  const state: IAppState = yield select();

  yield call(
    [globalPut, globalPut.put],
    globalActions.createStreckeSnapshot({ appId: App.VHV_V2, angebotsId: state.angebotsId }),
  );

  yield call([globalPut, globalPut.put], globalActions.setEditingUwApprovedOffer(false));

  yield put(new VhvActions().absprungInsDashboard());
}
